export const path = "/master-design-compao";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER DESIGN",
  section: "COMPAO",
  group: null,
  order: 1,
  roles: [
    "Authenticated",
    "design",
    "design-roundler",
    "roundler-admin",
    "aluna",
  ],
};
